<template>
  <div class="main">
    <dd-header />
    <div class="container">
      <!-- <dd-sitemap
        :pageKey="pageKey"
        :pageList="orderForm.pageList"
      /> -->
      <div id="content">
        <div class="title">
          <h2>
            <label>納品先入力画面</label>
          </h2>
        </div>
        <div class="input_list">
          <dd-business-input
            ref="businessInputRef"
            :label="label"
            :form="form"
          />
          <ul>
            <li class="input_text">
              <div>
                <label>{{label.deliveryDate}}<span class="important">必須</span></label>
                <span class="payment_caution">
                  <tool-tip ref="tooltipRef"
                   :img="imgQmark"
                   :text="'※銀行振込でご購入を検討のお客様へ'"
                   :messages="['商品は、入金確認後に製造開始いたします。',
                      'すみやかにご入金いただけない場合ご希望の納期に間に合わない場合がございます。',
                      'ご希望納期で商品の納品ができない場合、納期の再設定のご連絡を差し上げます。']"
                   :posClass="'postop'"
                   :top="-100"
                  />
                </span>
              </div>
            </li>
          </ul>
          <div class="list_day">
            <dd-calendar
              :schedule="schedule"
              :value="form.deliveryDate"
              @selectedDate="selectedDate"
            />
            <div class="time">
              <ul>
                <template v-if="mkid == 1">
                  <li>
                    <input type="radio" id="time0" name="target_time" :value="0" v-model="form.selectTime"/>
                    <label for="time0">指定なし</label>
                  </li>
                  <li>
                    <input type="radio" id="time1" name="target_time" :value="1" v-model="form.selectTime"/>
                    <label for="time1">午前中(8:00～12:00)</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="2" v-model="form.selectTime"/>
                    <label for="time2">午後(12:00～15:00)</label>
                  </li>
                </template>
                <template v-else>
                  <li>
                    <input type="radio" id="time0" name="target_time" :value="0" v-model="form.selectTime"/>
                    <label for="time0">指定なし</label>
                  </li>
                  <li>
                    <input type="radio" id="time1" name="target_time" :value="3" v-model="form.selectTime"/>
                    <label for="time1">10:00～12:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="4" v-model="form.selectTime"/>
                    <label for="time2">12:00～14:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="5" v-model="form.selectTime"/>
                    <label for="time2">14:00～16:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="6" v-model="form.selectTime"/>
                    <label for="time2">16:00～18:00</label>
                  </li>
                  <li>
                    <input type="radio" id="time2" name="target_time" :value="7" v-model="form.selectTime"/>
                    <label for="time2">18:00～20:00</label>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div v-if="errors.deliveryDate" class="error_text">{{errors.deliveryDate}}</div>
          <ul>
            <li class="input_text">
              <div>
                <label class="list_key">{{label.message}}</label>
              </div>
              <textarea class="list_box" v-model="form.message" cols="100" rows="5" maxlength="256" placeholder="配送時の連絡事項をご記入ください。"/>
            </li>
            <li>
              <div class="check_box" id="registAddress">
                <input type="checkbox" v-model="form.isRegistAddress"/>
                <label for="registAddress">納品先を登録する。</label>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        <div class="control_btn_area">
          <router-link to="/mmstyle/top">
            <button class="main_btn cancel_btn">戻る</button>
          </router-link>
          <button class="main_btn" :disabled="!isConfirm" @click="confirm()" v-if="orderForm.workFlag">組立設置情報入力</button>
          <button class="main_btn" :disabled="!isConfirm" @click="confirm()" v-else>ご注文内容確認</button>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../utils/Api'
import * as App from '../utils/App'
import * as Check from '../utils/Check'
import {DC_URL, DC_STORAGE_KEY} from '../constants/App'
import Calendar from '../components/common/Calendar'
import LoadingModal from '../components/common/LoadingModal'
// Module
import Header from '../components/Header'
// import SiteMap from '../components/common/SiteMap'
import BusinessInput from '../components/order/BusinessInput'
import ToolTip from '../components/common/ToolTip'

export default {
  name: 'DcOrderInput',
  components: {
    'dd-header': Header,
    // 'dd-sitemap': SiteMap,
    'dd-calendar': Calendar,
    'dd-loading-modal': LoadingModal,
    'dd-business-input': BusinessInput,
    'tool-tip': ToolTip
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'orderInput',
      form: {
        businessId: '',
        businessName: '',
        building: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        deliveryDate: '',
        message: '',
        selectTime: 0,
        isRegistAddress: false
      },
      // 入力保持用のフォーム
      topForm: {},
      orderForm: {},
      // 画面表示項目
      label: {
        businessName: '施主名(物件名)',
        building: '納品先名',
        postcd: '納品先郵便番号',
        address: '納品先住所',
        state: '住所',
        street: '以下、住所',
        userName: '受取人氏名',
        userNameKana: '受取人氏名（カナ）',
        tel: '受取人電話番号',
        deliveryDate: '納品希望日',
        message: '配送時の連絡事項'
      },
      errors: {},
      schedule: {},
      inputFlag: false,
      imgQmark: this.getImage('common/qmark_gray.svg')
    }
  },
  methods: {
    scheduling: function () {
      axios.get(DC_URL.SCHEDULE + '/delivery')
        .then(response => {
          this.schedule = response.data.data
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        })
    },
    selectedDate: function (selectedDate) {
      let format = 'YYYY-MM-dd'.replace(/YYYY/g, selectedDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (selectedDate.getMonth() + 1)).slice(-2))
      format = format.replace(/dd/g, ('0' + selectedDate.getDate()).slice(-2))
      this.form.deliveryDate = format
    },
    confirm: function () {
      // 入力チェック
      let retBusinessErr = this.$refs.businessInputRef.confirm()
      this.errors = {}
      this.validateRequire()
      if (!retBusinessErr || Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      // 多重防止
      if (this.inputFlag) return
      this.inputFlag = true
      this.$refs.loadingModalRef.showModal(true)
      App.setLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA, this.form)
      axios.post(DC_URL.ORDER + '/input', this.form)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
            this.$refs.loadingModalRef.showModal(false)
          } else {
            // 確認画面へ
            if (this.orderForm.workFlag) {
              this.$router.push({
                name: 'ConstructInput'
              })
            } else {
              this.$router.push({
                name: 'OrderConfirm'
              })
            }
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.inputFlag = false
        })
    },
    fetchData: function () {
      let lform = App.getLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
      if (Object.keys(lform).length > 0) {
        this.form = Object.assign({}, lform)
      }
      let ltop = App.getLocalStorage(DC_STORAGE_KEY.TOP_FORM)
      if (Object.keys(ltop).length > 0) {
        this.topForm = Object.assign({}, ltop)
      }
      let lorder = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      if (Object.keys(lorder).length > 0) {
        this.orderForm = Object.assign({}, lorder)
      }
    },
    validateRequire: function () {
      if (!this.form.deliveryDate) this.errors['deliveryDate'] = this.label.deliveryDate + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isDate(this.form.deliveryDate)) {
        this.errors['deliveryDate'] = this.label.deliveryDate + 'の日付の形式が間違っています。'
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  computed: {
    isConfirm: function () {
      if (this.form.postcd && this.form.state && this.form.city && this.form.street) {
        return true
      }
      return false
    },
    mkid: function () {
      if (this.orderForm.corpId === 27) return 1
      return 0
    }
  },
  watch: {
  },
  mounted () {
    // this.scheduling()
  },
  created () {
    // this.fetchData()
  }
}
</script>
<style src="../css/order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/pages/OrderInput.vue